/**
 * Breakpoints du lecteur spectateur : choisissent la cible d'affichage selon la largeur du device.
 * (Le compositor egress rend désormais un layout desktop unique pour les 4 flux, indépendamment d'ici.)
 */
export const BREAKPOINTS = { mobile: 768, tablet: 1024 } as const;

export type Breakpoint = 'mobile' | 'desktop';

export function getBreakpointFromWidth(width: number): Breakpoint {
  if (width >= BREAKPOINTS.tablet) return 'desktop';
  if (width >= BREAKPOINTS.mobile) return 'mobile';
  return 'mobile';
}
